import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customPath": "/about/contacts",
  "description": "Контактная информация компании «ŠKODA AUTO Россия». Онлайн-форма для обратной связи. Телефон круглосуточной горячей линии: 8 800 555-01-01.",
  "huggerTemplate": "default",
  "keywords": "контактная информация,контакты,обратная связь,SKODA,Шкода",
  "name": "contacts",
  "title": "Контакты компании ŠKODA AUTO Россия"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const Contacts = makeShortcode("Contacts");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="center" horizontalAlign="left" src="/m/finance_overview_stage.jpg" mobileSrc="/m/finance_overview_stage.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">Контакты</SimpleMainStageHeading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FFF" mdxType="DefaultPaddedSection">
  <Contacts data={{
        fizikPhone: "88005550101",
        coords: [55.656184, 37.526223],
        email: "skoda.hotline@vgrus.ru",
        address: "117485, Москва, ул. Обручева, д. 30/1"
      }} mdxType="Contacts" />
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      